import React from 'react';
import Sidebar from './Sidebar';
import MobileBottomNav from './MobileBottomNav';

const AuthenticatedLayout = ({ children, sidebarLinks }) => {
  return (
    <div className="app-layout">
      <Sidebar links={sidebarLinks} />
      <main className="main-content-area">
        {children}
      </main>
      <MobileBottomNav />
    </div>
  );
};

export default AuthenticatedLayout; 